export default __webpack_public_path__ + "static/media/sirocco-pay.9d57c8ec.jpg";